window.subscriptionFlow = {
    currentVariantId: null,
    sellingPlanId: null,
    productId: null,
    productSKU: null,
    productTitle: null,
    boxSequence: null,
    subscriptionSku: null,
    productType: null,
    originUrl: null,
};

class SubscriptionFunnel {
  constructor(container, isCart = false) {
        this.funnel = container;
        this.isHackpack = container?.getAttribute('data-subscription-funnel-hackpack');
        this.isCreative = container?.getAttribute('data-subscription-funnel-creative');
        this.interacted = 0;
        this.isCamp = container?.getAttribute('data-subscription-funnel-camp');
        this.isMysteries = container?.getAttribute('data-subscription-funnel-mysteries')

        if (this.funnel) {
            this.isCart = isCart;

            this._initCampDeliveryDatePicker();

            this.funnel.querySelectorAll("[data-subscriptionProduct]").forEach(ele =>
                ele.addEventListener("click", (event) => {
                    event.stopImmediatePropagation();
                    this._getSubscriptionDetails(event);       
                })
            )

            this.funnel.querySelectorAll("[open-subscription-popup]").forEach(ele =>
                ele.addEventListener("click", (event) => {
                    event.preventDefault();
                    if (window.subscriptions.enable_sub_limit) {
                        let quantityCount = 0;
                        window.globalVariables.cart.items.forEach(item => {
                            if (item.product_type === "Build a Box Subscription") {
                                quantityCount = quantityCount + item.quantity;
                            }
                        });

                        if (quantityCount >= window.subscriptions.product_limit) {
                            ele.closest("[data-product-form]")
                                ?.querySelector(".subscription_limit_error_msg")
                                .classList.remove("d-none");
                            return false;
                        }
                    }

                    ele.closest("[data-product-form]")
                        ?.querySelector(".subscription_limit_error_msg")
                        .classList.add("d-none");

                    this._openPopup(event);
        
                })
            );

            this.funnel.querySelectorAll("[add-subscription-product]").forEach(ele =>
                ele.addEventListener("click", (event) => {
                    event.preventDefault();
                    let type = event.currentTarget.getAttribute("type");
                    let pageType = document.querySelector('[data-box-type]').getAttribute('data-box-type');
                    if (type === 'direct') {
                      // Upsell-to-annual accept: if the annual (upsell) block has the free-book
                      // A/B flag on, bundle the free book onto the annual line too.
                      let upsellForm = document.querySelector('div[data-subscription-upsell="true"]');
                      let annualBtn = upsellForm?.querySelector('[add-subscription-productcheckout]');
                      let fbOn = annualBtn?.getAttribute('data-free-books') === '1';
                      let fbVariant = fbOn ? annualBtn?.getAttribute('data-free-books-variant') : null;
                      this._addToCart(type, event, true, false, null, fbVariant);
                      sessionStorage.setItem(`${pageType}`, "1");
                    } else {
                      this._addToCart(type, event);
                    }
                })
            );

            this.funnel.querySelectorAll("[add-subscription-productcheckout]").forEach(ele =>
              ele.addEventListener("click", (event) => {
                  event.preventDefault();
                  let currentEvent = event;
                  let type = event.currentTarget.getAttribute("procedure");

                  // A/B variant: when data-free-books="1", skip the mysteries popup and
                  // auto-add the configured free (zero-priced) book as a first-box bundled item.
                  let freeBooksOn = event.currentTarget.getAttribute('data-free-books') === '1';
                  let freeBooksVariant = event.currentTarget.getAttribute('data-free-books-variant');
                  if (freeBooksOn && freeBooksVariant) {
                    this._addToCart(type, currentEvent, false, false, null, freeBooksVariant);
                    return;
                  }

                  let isMysteriesUpsell = event.currentTarget.getAttribute('data-mysteries-upsell') === 'true';
                  let mysteriesVariant = event.currentTarget.getAttribute('data-mysteries-variant');
                  let additionalCheckbox = event.currentTarget.closest('form')?.querySelector('.js-additionalProduct');
                  let isAdditionalChecked = additionalCheckbox ? additionalCheckbox.checked : false;
                  let hasSeenMysteriesPopup = sessionStorage.getItem('mysteries_popup_seen') === '1';

                  if (isMysteriesUpsell && !hasSeenMysteriesPopup && mysteriesVariant && !isAdditionalChecked) {
                    let mysteriesModal = document.querySelector('[data-subscription-modal-mysteries]');
                    if (mysteriesModal) {
                        sessionStorage.setItem('mysteries_popup_seen', '1');
                      this.pendingMysteriesVariant = mysteriesVariant;
                      this.pendingMysteriesEvent = { currentTarget: event.currentTarget }; 
                      this.pendingMysteriesType = type;
                      mysteriesModal.classList.add('open');
                      try { siteOverlay.prototype.showOverlay(); } catch (e) {}
                      return; 
                    }
                  }

                  let popupShow = event.currentTarget.getAttribute('data-show-popup');
                  let popupEnabled = document.querySelector('[data-upsell-popup]').getAttribute('data-upsell-popup');
                  let interacted = event.currentTarget.getAttribute('data-interacted');
                  let dataSubscription = document.querySelector('[data-add-subscription]').closest('.product-popup').querySelector('[add-subscription-product]');
                  let continueBtn = document.querySelector('[data-add-subscription]').closest('.product-popup').querySelector('[data-continue]');
                  let pageType = document.querySelector('[data-box-type]').getAttribute('data-box-type');
                  popupShow === 'true' && interacted === 'true' && sessionStorage.getItem(`${pageType}`) !== '1' && popupEnabled === 'true'
                    ? [this._openPopupUpsell(type, event),dataSubscription.dataset.upsellValue = `Upsold from ` + this._activePlanName(), continueBtn.dataset.continue = `Continued purchase from ` + this._activePlanName()]
                    : this._addToCart(type, currentEvent);
              })
          );

          try{

            
            const inputs = document.querySelectorAll('.js-test');
            
            inputs.forEach(input => {
              input.addEventListener('change', (e) => {
                const checked = e.currentTarget.checked;
                inputs.forEach(i => {
                  if (i !== e.currentTarget) i.checked = checked;
                });
              });
            });
          }catch{}

        try{
            const inputs = document.querySelectorAll('.js-gwPseudo'); 
            
            inputs.forEach(input => {
              input.addEventListener('change', (e) => {
                const checked = e.currentTarget.checked;
                inputs.forEach(i => {
                  if (i !== e.currentTarget) i.checked = checked;
                });
              });
            });
          }catch{}

        try {
            const additionalProducts = document.querySelectorAll('.js-additionalProduct');

            additionalProducts.forEach(input => {
                input.addEventListener('change', (e) => {
                    const isChecked = e.currentTarget.checked;

                    additionalProducts.forEach(i => {
                        if (i !== e.currentTarget) i.checked = isChecked;
                    });

                    this._updateAddonsState();
                });
            });
        } catch(e) {
            console.error('Error binding additional product logic', e);
        }
          this._initMysteriesModal();
          // Expose pseudo-visibility so the cart-render path can re-run it (single owner).
          window.updateAddonPseudoVisibility = this._updateAddonPseudoVisibility.bind(this);
          if (!this.isCart) {
            this._selectedProduct();
          }
        }
    };

    /*
      This is for the camp subscription page.
      What this will do is check if the page is the camp page
      If it is the camp page, what we want to do is add the flatpickr calendar events to the necessary fields
    */
    _initCampDeliveryDatePicker() {
        if (this.isCamp !== 'true') return;

        const deliveryDateInput = this.funnel.querySelector('#delivery-date');
        const inputWrapper = deliveryDateInput?.closest('.input-wrapper');
        
        if (!deliveryDateInput || !inputWrapper) return;

        const calendarContainer = document.createElement('div');
        calendarContainer.classList.add('inline-calendar-wrapper');
        calendarContainer.style.display = 'none';
        
        inputWrapper.parentNode.insertBefore(calendarContainer, inputWrapper.nextSibling);

        flatpickr(deliveryDateInput, {
            inline: true,                
            appendTo: calendarContainer, 
            minDate: new Date().fp_incr(3),
            maxDate: "2026-07-31",
            monthSelectorType: "static", 
            dateFormat: "F j, Y",
            locale: {
                weekdays: {
                    shorthand: ["SU", "MO", "TU", "WE", "TH", "FR", "SA"],
                    longhand: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
                }
            },
            prevArrow: '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="0.5" y="0.5" width="39" height="39" rx="19.5" fill="white"/><rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M17.707 28.207C17.3165 28.5975 16.6835 28.5975 16.293 28.207L8.79297 20.707C8.40244 20.3164 8.40245 19.6834 8.79297 19.2929L16.293 11.7929C16.6835 11.4024 17.3165 11.4024 17.707 11.7929C18.0975 12.1834 18.0976 12.8164 17.707 13.207L11.9141 18.9999L30.5 18.9999C31.0523 18.9999 31.5 19.4476 31.5 19.9999C31.5 20.5522 31.0523 20.9999 30.5 20.9999L11.9141 20.9999L17.707 26.7929C18.0975 27.1834 18.0976 27.8164 17.707 28.207Z" fill="#282828"/></svg>',
            nextArrow: '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="0.5" y="0.5" width="39" height="39" rx="19.5" fill="white"/><rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M22.293 11.7929C22.6835 11.4024 23.3165 11.4024 23.707 11.7929L31.207 19.293C31.5976 19.6835 31.5976 20.3165 31.207 20.707L23.707 28.207C23.3165 28.5975 22.6835 28.5975 22.293 28.207C21.9024 27.8165 21.9024 27.1835 22.293 26.7929L28.0859 21H9.5C8.94772 21 8.50001 20.5523 8.5 20C8.5 19.4477 8.94772 19 9.5 19H28.0859L22.293 13.207C21.9024 12.8165 21.9024 12.1835 22.293 11.7929Z" fill="#282828"/></svg>',
            
            onReady: function(selectedDates, dateStr, instance) {
                const infoBox = document.createElement("div");
                infoBox.classList.add("custom-info-box");
                infoBox.innerHTML = `
                  <svg class="icon" viewBox="0 0 24 24" style="flex-shrink: 0; width: 20px; height: 20px;"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
                  <div>We will do our best to ship your first box on the date you select.</div>
                `;
                instance.calendarContainer.appendChild(infoBox);

                const titleBar = document.createElement('div');
                titleBar.classList.add('camp-calendar-title-bar');
                titleBar.classList.add('d-lg-none');

                const titleText = document.createElement('span');
                titleText.textContent = 'Delivery date';
                titleText.classList.add('camp-calendar-title-text');
                titleBar.appendChild(titleText);

                const closeBtn = document.createElement('span');
                closeBtn.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>';
                closeBtn.classList.add('camp-calendar-close-btn');
                closeBtn.style.cursor = 'pointer';
                
                closeBtn.addEventListener('click', () => {
                    calendarContainer.style.display = 'none';
                });
                titleBar.appendChild(closeBtn);

                instance.calendarContainer.prepend(titleBar);
                
            },
            onChange: ()=> {
                calendarContainer.style.display = 'none';
                this._updateAddonsState();
            }
        });

        inputWrapper.addEventListener('click', () => {
            if (calendarContainer.style.display === 'none') {
                calendarContainer.style.display = 'block';
            } else {
                calendarContainer.style.display = 'none';
            }
        });
    }
    
    _selectedProduct() {
        const urlParams = new URLSearchParams(window.location.search);
        const targetHandle = urlParams.get('product-handle');
        let matchFound = false;

        const isOldVersion = this.funnel.classList.contains('old-version');
        const activeContainerSelector = isOldVersion ? '.subscription-main.old-version' : '.subscription-main.new-version';
        const activeContainer = this.funnel.querySelector(activeContainerSelector);

        if (!activeContainer) return;

        if (targetHandle) {
            const targetElement = activeContainer.querySelector(`[data-subscriptionProduct="${targetHandle}"]`);
            
            if (targetElement) {
                targetElement.click();
                this.interacted++;
                matchFound = true; 
            }
        } 

        if (!matchFound) {
            const firstOption = activeContainer.querySelector("[data-subscriptionProduct]");
            if (firstOption) {
                firstOption.click();
                this.interacted++;
            }
        }
    }
    
    _updateAddonsState() {
        const additionalProducts = document.querySelectorAll('.js-additionalProduct');
        const gwCheckboxes = document.querySelectorAll('.js-gwPseudo');
        const esCheckboxes = document.querySelectorAll('.js-test');
        const deliveryDateInput = this.funnel.querySelector('#delivery-date');

        let isAdditionalChecked = false;
        additionalProducts.forEach(input => {
            if (input.checked) isAdditionalChecked = true;
        });

        let hasDate = false;
        if (deliveryDateInput && deliveryDateInput.value.trim() !== '') {
            hasDate = true;
        }

        let isSingle = window.subscriptionFlow && window.subscriptionFlow.isSingle === true;
        const shouldDisable = isAdditionalChecked || hasDate || isSingle;

        gwCheckboxes.forEach(gw => {
            gw.disabled = shouldDisable; 
            if (shouldDisable && gw.checked) {
                gw.checked = false;
                gw.dispatchEvent(new Event('change')); 
            }
        });

        esCheckboxes.forEach(es => {
            es.disabled = shouldDisable;
            if (shouldDisable && es.checked) {
                es.checked = false;
                es.dispatchEvent(new Event('change'));
            }
        });

        this._updateAddonPseudoVisibility();
    }

    // Show/hide the subscription-page pseudo checkboxes from eligibility of the product
    // being configured (resolved: currentVariantId, or preorderVariantId when a delivery
    // date is set) plus current-cart compatibility. Single owner of pseudo visibility —
    // called on selection/date/additional change (via _updateAddonsState) and on cart
    // render (via window.updateAddonPseudoVisibility). See expedited-discreet-packaging.md §9/§11.
    _updateAddonPseudoVisibility() {
        if (!window.AddonEligibility) return;
        window.AddonEligibility.ready().then(function () {
            var flow = window.subscriptionFlow || {};
            var dateInput = document.querySelector('#delivery-date');
            var hasDate = dateInput && dateInput.value && dateInput.value.trim() !== '';
            var resolvedVariantId = (hasDate && flow.preorderVariantId) ? flow.preorderVariantId : flow.currentVariantId;
            var cartItems = (window.globalVariables && window.globalVariables.cart && window.globalVariables.cart.items) || [];

            var apply = function (selector, addon) {
                var labels = document.querySelectorAll(selector);
                if (!labels.length) return;
                var show = window.AddonEligibility.isEligible(resolvedVariantId, addon)
                        && window.AddonEligibility.cartAllowsAddon(cartItems, addon);
                labels.forEach(function (label) {
                    label.classList.toggle('d-none', !show);
                    if (!show) {
                        var cb = label.querySelector('input[type="checkbox"]');
                        if (cb && cb.checked) { cb.checked = false; cb.dispatchEvent(new Event('change')); }
                    }
                });
            };
            apply('.pseudo-gw-shipping', 'discreet');
            apply('.pseudo-expedited-shipping', 'expedited');
        });
    }

    _initMysteriesModal() {
      const mysteriesModal = document.querySelector('[data-subscription-modal-mysteries]');
        if (!mysteriesModal) return;

        const acceptBtn = mysteriesModal.querySelector('[data-mysteries-accept]');
        const declineBtn = mysteriesModal.querySelector('[data-mysteries-decline]');

        if (acceptBtn) {
            acceptBtn.addEventListener('click', (e) => {
                e.preventDefault();
                acceptBtn.classList.add('loading');
                sessionStorage.setItem('mysteries_popup_seen', '1');
                this._addToCart(this.pendingMysteriesType, this.pendingMysteriesEvent, false, false, this.pendingMysteriesVariant);
            });
        }

        if (declineBtn) {
            declineBtn.addEventListener('click', (e) => {
                e.preventDefault();
                declineBtn.classList.add('loading'); 
                sessionStorage.setItem('mysteries_popup_seen', '1');
                mysteriesModal.classList.remove('open');
                try { siteOverlay.prototype.hideOverlay(); } catch (e) {}

          this._addToCart(this.pendingMysteriesType, this.pendingMysteriesEvent);
        });
      }
    }


    _getSubscriptionDetails(event) {
      this.interacted++;
      if (this.interacted >= 2) {
          document.querySelectorAll('[data-interacted]').forEach(item => item.setAttribute('data-interacted', true));
      }

      let currentElement = event.currentTarget;
      
      currentElement.parentNode.parentNode.querySelectorAll("[data-subscriptionProduct].active").forEach(ele => {
        ele.classList.remove("active");
      });
      
      currentElement.classList.add("active");

      if (!this.isCart) {
        const url = new URL(window.location.href); 
        const searchParams = url.searchParams;
        searchParams.set("product-handle", currentElement.getAttribute('data-subscriptionProduct'));
        document.querySelector('.subscription-camp')
          ? null
          : document.querySelector('meta[property="og:price:amount"]')?.setAttribute('content', currentElement.querySelector('[data-price-attr]')?.getAttribute('data-price-attr'));
          url.search = searchParams.toString();
            const newUrl = url.pathname + url.search;
            window.history.replaceState({}, '', newUrl);
        }

        let formSelector = currentElement.getAttribute('data-formcontent');
        let productForm = this.funnel.querySelector(formSelector);

        let subItem = currentElement.querySelector('.sub-item');
        let isSingle = subItem?.getAttribute('data-single') === 'true';
        let stringSkus = subItem?.getAttribute('data-products');
        let stringVariantIds = subItem?.getAttribute('data-variant-ids');
        
        subscriptionFlow.currentVariantId = productForm?.querySelector('[name="id"]')?.value;
        subscriptionFlow.sellingPlanId = productForm?.querySelector('[name="selling_plan"]')?.value;
        subscriptionFlow.productType = productForm?.querySelector('[data-product-type]')?.value || null;
        subscriptionFlow.preorder = productForm?.querySelector('[name="preorder"]')?.value || null;
        subscriptionFlow.originUrl = productForm?.querySelector('[name="origin_url"]')?.value || null;

        subscriptionFlow.preorderVariantId = subItem?.getAttribute('data-preorder-id') || null;
        subscriptionFlow.preorderSku = subItem?.getAttribute('data-preorder-sku') || null;
        subscriptionFlow.isSingle = isSingle;
        subscriptionFlow.campVariantIds = stringVariantIds ? stringVariantIds.split(',').filter(id => id.trim() !== '') : [];

        const datePickerContainer = this.funnel.querySelector('.datepicker-container');
        const deliveryDateInput = this.funnel.querySelector('#delivery-date');

        if (datePickerContainer) {
            if (isSingle) {
                datePickerContainer.classList.add('d-none'); 
                
                if (deliveryDateInput) {
                    if (deliveryDateInput._flatpickr) {
                        deliveryDateInput._flatpickr.clear();
                    } else {
                        deliveryDateInput.value = ''; 
                    }
                }
            } else {
                datePickerContainer.classList.remove('d-none'); 
            }
        }
        subscriptionFlow.preorderSellingPlanId = subItem?.getAttribute('data-preorder-selling-plan') || null;

        if (window.subscriptions.enable_sequencing) {
            if((subscriptionFlow.originUrl.includes('camp') && window.subscriptions.enable_camp_sequence) || (currentElement.getAttribute('data-subscriptionproduct').includes('camp') && window.subscriptions.enable_camp_sequence) ){
              window.boxSequenceApi.getCampSequenceProperties().then(result => {
                Object.assign(window.subscriptionFlow, result);

              })
            }
            else if(subscriptionFlow.originUrl.includes('build') && window.subscriptions.enable_sequencing){
              window.boxSequenceApi.getBoxSequenceProperties().then(result => {
                Object.assign(window.subscriptionFlow, result);

              });
            }
            else if(subscriptionFlow.originUrl.includes('hack') && window.subscriptions.enable_hack_sequence){
              window.boxSequenceApi.getHackSequenceProperties().then(result => {
                Object.assign(window.subscriptionFlow, result);

              });
            }
            else if(subscriptionFlow.originUrl.includes('creative') && window.subscriptions.enable_ck_sequence){
              window.boxSequenceApi.getCreativeSequenceProperties().then(result => {
                Object.assign(window.subscriptionFlow, result);
              })
            }
            else{
              subscriptionFlow.productId = productForm?.querySelector('[name="product_id"]')?.value;
              subscriptionFlow.productSKU = (isSingle && stringSkus) ? stringSkus : productForm?.querySelector('[name="product_sku"]')?.value;
              subscriptionFlow.productTitle = productForm?.querySelector('[name="product_title"]')?.value;
            }
        } else {
            /* old way */
            subscriptionFlow.productId = productForm?.querySelector('[name="product_id"]')?.value;
            subscriptionFlow.productSKU = (isSingle && stringSkus) ? stringSkus : productForm?.querySelector('[name="product_sku"]')?.value;
            subscriptionFlow.productTitle = productForm?.querySelector('[name="product_title"]')?.value;
        }
        this._updateAddonsState();
    };

    _openPopup(event) {
        let form = event.currentTarget.closest("form");
        let quantity = parseInt(form.querySelector("[data-quantity-value]").value);
        this.funnel.querySelector("[data-subscriber-info]").innerHTML = "";
        let finalHtml = "";

        if (quantity === 1) {
            this.funnel.querySelector("[data-subscription-modal]").classList.add("single-subscription");
        } else {
            document.querySelector("[data-subscription-modal]").classList.remove("single-subscription");
        }

        for (let index = 1; index <= quantity; index++) {
            let html = `
            <form data-subscriber-form>
            <div data-subscriber-details>
                <h6 class="font-size-lg text-uppercase mb-2 pb-1">SUBSCRIPTION #${index}</h6>
                <div class="form-floating name-label mb-3">
                    <input type="text" id="fname_${index}" name="fname" class="form-control" placeholder="Name" required data-nickname>
                    <label class="w-100 d-flex justify-content-between" for="fname_${index}"><div class="me-2">Name<span class="text-gray-700 fw-normal ms-1">(or nickname!)</span></div><span class="text-gray-700 fw-normal label-optional">required*</span></label>
                </div>

                <div class="form-floating birthday-label mb-3 mb-lg-3">
                    <input type="text" id="datepicker_${index}" name="birthdate" class="form-control" placeholder="Their Birthday" data-birthdate> 
                    <label for="datepicker_${index}"><div class="me-2">Their Birthday<span class="text-gray-700 fw-normal ms-1">(MM/DD/YYYY)</span></div><span class="text-gray-700 fw-normal label-optional">${window.subscriptions.birthday_required ? 'required*' : 'optional*' }</span></label>
                    <p class="mt-1 subscription-quantity font-size-xs fst-italic">${window.subscriptions.optional_text}</p>
                </div>
            </div> 
            </form>`
            finalHtml = finalHtml + html;
        }
        this.funnel.querySelector("[data-subscriber-info]").innerHTML = finalHtml;
        this.funnel.querySelector("[data-subscription-modal]").classList.add("open");
        this.funnel.querySelectorAll("[data-birthdate]").forEach(ele => {
            ele.addEventListener("change", (ele) => {
                this._checkBirthDate();
            })
        })

        siteOverlay.prototype.showOverlay();
        this._flatPickerTrigger();

        this.funnel.querySelectorAll("[data-subscriber-details]").forEach(ele => {
            ele.addEventListener("keyup", (ele) => {
                this._checkInputValue();
            })
        })
    }
    // Plan name of the selected tab for data-upsell-value / data-continue. GTM sends these
    // as GA4 event names, so the text must stay exactly as before: the legacy selector is
    // tried first (live theme, value unchanged); the redesign's .sub-plan has no
    // fw-medium/text-black, so fall back to the visible active tab there.
    _activePlanName() {
        const legacy = document.querySelector('.tablink.active .sub-plan.fw-medium.text-black');
        if (legacy) return legacy.innerText;
        const tabs = [...document.querySelectorAll('.tablink.active')];
        const tab = tabs.find((t) => t.offsetParent !== null) || tabs[0];
        return tab?.querySelector('.sub-plan')?.innerText.trim() || '';
    }

    _openPopupUpsell(type, event) {
      let form = event.currentTarget.closest("form");
      let quantity = parseInt(form.querySelector("[data-quantity-value]").value);
      let pageType = document.querySelector('[data-box-type]').getAttribute('data-box-type');
      let continueBtn = document.querySelector('[data-add-subscription]');
      continueBtn.addEventListener('click', (e) => {
        continueBtn.classList.add('loading');
        sessionStorage.setItem(`${pageType}`, "1");
        this._addToCart(type, event);
      })


      this.funnel.querySelector("[data-subscriber-info]").innerHTML = "";
      let finalHtml = "";

      if (quantity === 1) {
          this.funnel.querySelector("[data-subscription-modal]").classList.add("single-subscription");
      } else {
          document.querySelector("[data-subscription-modal]").classList.remove("single-subscription");
      }

      this.funnel.querySelector("[data-subscriber-info]").innerHTML = finalHtml;
      this.funnel.querySelector("[data-subscription-modal]").classList.add("open");
      this.funnel.querySelectorAll("[data-birthdate]").forEach(ele => {
          ele.addEventListener("change", (ele) => {
              this._checkBirthDate();
          })
      })

      siteOverlay.prototype.showOverlay();
      this._flatPickerTrigger();

      this.funnel.querySelectorAll("[data-subscriber-details]").forEach(ele => {
          ele.addEventListener("keyup", (ele) => {
              this._checkInputValue();
          })
      })
    }

    _checkBirthDate() {
        let flag = false;
        this.funnel.querySelectorAll("[data-birthdate]").forEach(ele => {
            if ((this._dateMethods(new Date())) < (new Date(ele.value))) {
                flag = true;
            }
        });
        if (flag) {
            this.funnel.querySelector("[data-child-info]").classList.remove("d-none");
        } else {
            this.funnel.querySelector("[data-child-info]").classList.add("d-none");
        }
    };

    _dateMethods(date) {
        return new Date(date.setFullYear(date.getFullYear() - parseInt(5)));
    }

    _checkInputValue() {
        let formInvalid = false;
        this.funnel.querySelectorAll("[data-nickname]").forEach(ele => {
            let inputValue = ele.value.trim();
            if (!inputValue || inputValue.length <= 0) {
                formInvalid = true;
            }
        });

        if(window.subscriptions.birthday_required) {
          this.funnel.querySelectorAll("[data-birthdate]").forEach(ele => {
            let inputValue = ele.value.trim();
            if (!inputValue || inputValue.length <= 0) {
                formInvalid = true;
            }
          });
        }

        if (formInvalid) {
            this.funnel.querySelectorAll("[add-subscription-product]").forEach(ele => {
                ele.setAttribute("disabled", 'true');
            })
        } else {
            this.funnel.querySelectorAll("[add-subscription-product]").forEach(ele => {
                ele.removeAttribute("disabled");
            })
        }
    }

    _flatPickerTrigger() {
        this.funnel.querySelectorAll("[data-birthdate]").forEach(ele => {
            flatpickr(ele, {
                allowInput: true,
                altInput: true,
                maxDate: "today",
                dateFormat: "Y-m-d",
                disableMobile: true,
                parseDate: (datestr, format) => {
                    return new Date(datestr.replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3"));
                },
                onReady: (selectedDates, dateStr, instance) => {
                    console.log(instance)
                },
                onClose: (() => {
                  this._checkInputValue();
                })
            });
        });
    }

    async _addToCart(type, event, upsell = false, skipExpeditedGuard = false, mysteriesVariantId = null, freeBooksVariantId = null) {
        if (!subscriptionFlow.currentVariantId || !subscriptionFlow.sellingPlanId) {
            notificationEle.updateNotification("Error", "Error while adding subscription to your cart", {
                type: "error",
                timeout: 2000
            });
            return false;
        }

        const items = [];
        let currentElement = event.currentTarget || event.originalTarget;
        currentElement?.classList.add("loading");

        let attachedVariantId = currentElement?.getAttribute('data-attached-product');
        let attachedTitle = currentElement?.getAttribute('data-attached-title');
        let attachedSku = currentElement?.getAttribute('data-attached-sku');
        let attachedGroupId = attachedVariantId ? (Date.now() + Math.floor(Math.random() * 1000)) : null;
        let freeBooksGroupId = freeBooksVariantId ? (Date.now() + Math.floor(Math.random() * 1000)) : null;
        // In the upsell=true path, currentElement is the generic accept button (no free-book
        // attrs); the free-book metadata lives on the annual block's checkout button instead.
        let freeBooksSourceEl = currentElement;
        if (upsell === true) {
            let fbForm = document.querySelector('div[data-subscription-upsell="true"]');
            freeBooksSourceEl = fbForm?.querySelector('[add-subscription-productcheckout]') || currentElement;
        }

        let additionalCheckbox;
        if(upsell === true){
            let productForm = document.querySelector('div[data-subscription-upsell="true"]');
            additionalCheckbox = productForm?.querySelector('.js-additionalProduct');
        } else {
            additionalCheckbox = currentElement?.closest('form')?.querySelector('.js-additionalProduct');
        }
        let additionalVariantId = additionalCheckbox?.checked ? additionalCheckbox.getAttribute('data-id') : null;

        const subscriptionSelected = document.querySelector('#productTabsContent .open input[name="subscription_handle"]').value;
        if(upsell === true){
          let dataSubscription = document.querySelector('[data-add-subscription]').closest('.product-popup').querySelector('[add-subscription-product]');
          let productForm = document.querySelector('div[data-subscription-upsell="true"]');
          dataSubscription.dataset.upsellValue = this._activePlanName();
          subscriptionFlow.currentVariantId = productForm?.querySelector('[name="id"]')?.value;
          subscriptionFlow.sellingPlanId = productForm?.querySelector('[name="selling_plan"]')?.value;
          subscriptionFlow.productType = productForm?.querySelector('[data-product-type]')?.value || null;
          subscriptionFlow.preorder = productForm?.querySelector('[name="preorder"]')?.value || null;
          subscriptionFlow.originUrl = productForm?.querySelector('[name="origin_url"]')?.value || null;
        }

        // Expedited conflict guard removed: subscription adds always proceed, and any
        // incompatible add-on (expedited) drops silently via the pre-add sync + cart
        // re-render — consistent with how discreet packaging already behaves. No blocking
        // modal for subscription adds (see expedited-discreet-packaging.md §3.3).

        const activeSubscriptions = document.querySelectorAll('.subscription-main.new-version [data-subscription-title].active');
        if (activeSubscriptions.length > 0) {
          activeSubscriptions.forEach(element => {
            const subscriptionTitle = element.getAttribute('data-subscription-title');
            const subscriptionTitleWords = subscriptionTitle.split(' ');
            const subscriptionLastWord = subscriptionTitleWords[subscriptionTitleWords.length - 1];
            const subscriptionLastWordLowerCase = subscriptionLastWord.toLowerCase();
            const subscriptionType = subscriptionLastWordLowerCase;
          });
        } 
        else {
          console.log('No active subscriptions found');
        }

        let deliveryDateVal = '';
        if (this.isCamp === 'true') {
            const deliveryDateInput = this.funnel.querySelector('#delivery-date');
            
            const fpInstance = deliveryDateInput?._flatpickr;

            if (fpInstance && fpInstance.selectedDates.length > 0) {
                const rawDate = fpInstance.selectedDates[0];
                
                const year = rawDate.getFullYear();
                const month = String(rawDate.getMonth() + 1).padStart(2, '0');
                const day = String(rawDate.getDate()).padStart(2, '0');
                
                deliveryDateVal = `${year}-${month}-${day}`; 
            } else if (deliveryDateInput && deliveryDateInput.value.trim() !== '') {
                deliveryDateVal = deliveryDateInput.value.trim();
            }
        }

        let finalVariantId = subscriptionFlow.currentVariantId;
        let finalSellingPlanId = subscriptionFlow.sellingPlanId;

        if (deliveryDateVal && subscriptionFlow.preorderVariantId) {
            finalVariantId = subscriptionFlow.preorderVariantId;
            
            if (subscriptionFlow.preorderSellingPlanId) {
                finalSellingPlanId = subscriptionFlow.preorderSellingPlanId;
            } else {
                finalSellingPlanId = null;
            }
        }

        if(type == 'direct'){
          let subscriptionData = {};

          try{
            let customerDetails = await window.rechargeHelper._getCustomerDetails();
            let allSubscriptions = customerDetails.include.subscriptions;
            allSubscriptions.sort((a, b) => {
                {
                    if (a.next_charge_scheduled_at == null) return 1;
                    if (b.next_charge_scheduled_at == null) return -1;
                    return new Date(a.next_charge_scheduled_at) - new Date(b.next_charge_scheduled_at);
                }
            });
            let activeSubscription = [];
            for (let order of allSubscriptions) {
                switch (order.status.toUpperCase()) {
                    case "ACTIVE":
                        activeSubscription.push(order);
                        break;
                    case "EXPIRED":
                    case "CANCELLED":
                        break;
                }
            }
            activeSubscription?.length > 0 
            ? subscriptionData['_activeSubscriber'] = 'true'
            : null;
          }catch{console.log('not logged in')}

          let randomNumber = Math.floor((Math.random() * 1000) + 1);
          subscriptionData['_box_identifier'] = `${randomNumber}`;
          subscriptionData['_is_pause'] = "false";
          
          if (deliveryDateVal) {
            subscriptionData['_camp_preorder'] = deliveryDateVal;
          }

          if (subscriptionFlow.isSingle) {
            subscriptionData['_single_delivery'] = true;
          }
          
          try{
          if(currentElement.getAttribute('data-start')){
            subscriptionData['starting_at_box_number'] = currentElement.getAttribute('data-start');
            if(currentElement.getAttribute('data-prepaid')){
              subscriptionData['_initial_flat_discount'] = true;
              subscriptionData['_offline_purchase'] = true;
              subscriptionData['_book_fair'] = true;
            }
          }
        }catch{}
          if (attachedGroupId) {
            subscriptionData['_attached_item'] = attachedTitle;
            subscriptionData['_attached_id'] = attachedGroupId;
          }
          if (freeBooksGroupId) {
            // Mark the subscription as the bundle parent so the free book child is
            // auto-removed by _validateOrphans() when the subscription is removed.
            subscriptionData['_bundle_id'] = freeBooksGroupId;
            subscriptionData['bundled_item'] = "First Box";
          }
          let itemPayload = {
              quantity: 1,
              id: parseInt(finalVariantId),
              properties: subscriptionData
          };

          if (finalSellingPlanId && !isNaN(parseInt(finalSellingPlanId))) {
              itemPayload.selling_plan = parseInt(finalSellingPlanId);
          }

          items.push(itemPayload);
        }

      try {
        if (additionalVariantId) {

              let mysteriesId = currentElement?.getAttribute('data-mysteries-id') || '';
              let mysteriesSku = currentElement?.getAttribute('data-mysteries-sku') || '';
              let mysteriesTitle = currentElement?.getAttribute('data-mysteries-title') || '';
              let currentUrl = window.location.href;
              let upsellID = (Date.now() + Math.floor(Math.random() * 1000));
              let mysteriesChildVariantId = currentElement?.getAttribute('data-mysteries-variant-id'); 
              let additionalSellingPlanId = additionalCheckbox?.getAttribute('data-selling-plan');

              let mysteriesProperties = {
                '_box_identifier': `${Math.floor((Math.random() * 1000) + 1)}`,
                '_is_pause': "false",
                '_mystery_box_sequence': window.subscriptions ? window.subscriptions.default_mysteries_collection : '',
                '_directorder': true,
                '_product_id': mysteriesId,
                'product_sku': mysteriesSku,
                '_product_title': mysteriesTitle,
                '_origin_url': currentUrl,
                '_origin_url_2': currentUrl,
                'bundled_item': "First Box",
                '_bundle_id': upsellID
              };

              let additionalItemPayload = {
                  id: parseInt(additionalVariantId),
                  quantity: 1,
                  properties: mysteriesProperties
              };

              if (additionalSellingPlanId && !isNaN(parseInt(additionalSellingPlanId))) {
                  additionalItemPayload.selling_plan = parseInt(additionalSellingPlanId);
              }

              items.push(additionalItemPayload);

              if (mysteriesChildVariantId) {
                  items.push({
                      id: parseInt(mysteriesChildVariantId),
                      quantity: 1,
                      properties: {
                          '_bundled_product': true,
                          '_bundle_id': upsellID 
                      }
                  });
              }
        }
      } catch (e) {
        console.error("Error adding additional product", e);
      }

      try {
          if (mysteriesVariantId) {
              let mysteriesId = currentElement?.getAttribute('data-mysteries-id') || '';
              let mysteriesSku = currentElement?.getAttribute('data-mysteries-sku') || '';
              let mysteriesTitle = currentElement?.getAttribute('data-mysteries-title') || '';
              let currentUrl = window.location.href;
              let upsellID = (Date.now() + Math.floor(Math.random() * 1000));
              let mysteriesChildVariantId = currentElement?.getAttribute('data-mysteries-variant-id'); 
              let mysteriesSellingPlanId = document.querySelector('.tab-pane.tabcontent.open .js-additionalProduct').getAttribute('data-selling-plan');

              let mysteriesProperties = {
                '_box_identifier': `${Math.floor((Math.random() * 1000) + 1)}`,
                '_is_pause': "false",
                '_mystery_box_sequence': window.subscriptions ? window.subscriptions.default_mysteries_collection : '',
                '_directorder': true,
                '_product_id': mysteriesId,
                'product_sku': mysteriesSku,
                '_product_title': mysteriesTitle,
                '_origin_url': currentUrl,
                '_origin_url_2': currentUrl,
                'bundled_item': "First Box",
                '_bundle_id': upsellID
              };

              let mysteriesItemPayload = {
                  id: parseInt(mysteriesVariantId),
                  quantity: 1,
                  properties: mysteriesProperties
              };

              if (mysteriesSellingPlanId && !isNaN(parseInt(mysteriesSellingPlanId))) {
                  mysteriesItemPayload.selling_plan = parseInt(mysteriesSellingPlanId);
              }

              items.push(mysteriesItemPayload);

              if (mysteriesChildVariantId) {
                  items.push({
                      id: parseInt(mysteriesChildVariantId),
                      quantity: 1,
                      properties: {
                          '_bundled_product': true,
                          '_bundle_id': upsellID 
                      }
                  });
              }
          }
      } catch (e) {
          console.error("Error adding mysteries product", e);
      }

      try {
          if (freeBooksVariantId && freeBooksGroupId) {
              // A/B variant: zero-priced first-box book, one-time (no selling plan),
              // bundled to the subscription so it removes with it.
              items.push({
                  id: parseInt(freeBooksVariantId),
                  quantity: 1,
                  properties: {
                      '_bundled_product': true,
                      '_bundle_id': freeBooksGroupId,
                      // Lets subscription-line-check tell this apart from a first-box preview
                      // child, so it adopts the book instead of purging it as a rogue line.
                      '_free_book': 'true',
                      '_product_title': freeBooksSourceEl?.getAttribute('data-free-books-title') || '',
                      'product_sku': freeBooksSourceEl?.getAttribute('data-free-books-sku') || '',
                      'bundled_item': 'First Box'
                  }
              });
          }
      } catch (e) {
          console.error("Error adding free book product", e);
      }

      try {
        if (attachedVariantId) {
            const parentItemCount = items.filter(i => 
                !i.properties._bundled_product && 
                !i.properties._attached_product
            ).reduce((sum, item) => sum + item.quantity, 0);

            if (parentItemCount > 0) {
                items.push({
                    id: parseInt(attachedVariantId),
                    quantity: parentItemCount, 
                    properties: {
                        '_attached_product': true,
                        '_attached_id': attachedGroupId,
                        'product_sku': attachedSku
                    }
                });
            }
        }
      } catch (e) {
        console.error("Error adding attached product", e);
      }
        const pseudoCheckbox = document.querySelector('.js-test');
        const expeditedCheckbox = document.querySelector('#data-subscription-funnel .expedited-shipping-checkbox');
        const gwPseudoCheckbox = document.querySelector('.js-gwPseudo');
        const gwCheckbox = document.querySelector('#data-subscription-funnel .js-inputcheck');

        // Eligibility gate: an add-on stays only if EVERY real product being added in this
        // call is eligible for it. We iterate the built `items` list (main sub + mysteries
        // upsell + additional product), skipping structural lines (bundled/attached children)
        // exactly like the cart side. If any real added item is ineligible, force that add-on
        // OFF so processGiftWrappingForCartItem removes it now — before /cart/add + the redirect
        // (silent, no modal). Falls back to prior behavior if the module isn't loaded.
        // See expedited-discreet-packaging.md §9/§11.
        await window.AddonEligibility?.ready();
        const eligibleForAll = function (addon) {
          if (!window.AddonEligibility) return true;
          return items.every(function (it) {
            var props = it.properties || {};
            if (props._bundled_product || props._attached_product || props._attached_id) return true; // structural — skip
            return window.AddonEligibility.isEligible(it.id, addon);
          });
        };
        const discreetOk  = eligibleForAll('discreet');
        const expeditedOk = eligibleForAll('expedited');

        if (gwPseudoCheckbox && gwCheckbox) {

          gwCheckbox.checked = gwPseudoCheckbox.checked && discreetOk;

          try {
            await Shopify.Cart.GiftWrap.processGiftWrappingForCartItem(null, true, null, true);

          } catch (error) {
            console.error('Error updating discreet packaging state:', error);
            currentElement?.classList.remove("loading");
            return;
          }
        }

        if (pseudoCheckbox && expeditedCheckbox) {

          expeditedCheckbox.checked = pseudoCheckbox.checked && expeditedOk;

          try {
            await Shopify.Cart.GiftWrap.processGiftWrappingForCartItem(null, true, null, true);

          } catch (error) {
            console.error('Error updating expedited shipping state:', error);
            currentElement?.classList.remove("loading");
            return;
          }
        }

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({items: items}),
        })
            .then(response => {
                return response.json();
            })
            .then(async response => {
                if (response.items[0]) {
                    const item = response.items[0];
                    const props = item.properties;
                    const itemKey = `${props._product_id}-${props._box_identifier}`;
                    await Shopify.Cart.GiftWrap.processGiftWrappingForCartItem(itemKey, true, null, true).then(() => {
                      if (type === "cart") {
                        window.location.href = "/cart";
                        currentElement.classList.remove("loading");
                      } else {
                        window.location.href = "/checkout";
                        currentElement.classList.remove("loading");
                      }
                    })
                }
            }).catch(e => {
            console.log(e);
            currentElement.classList.remove("loading");
        });
    }
}

new SubscriptionFunnel(document.querySelector("#data-subscription-funnel"));

window.subscriptionFunnelClass = SubscriptionFunnel;